module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_waso_studio@3x-21575e403e00b8c429470fe645bea148.webp";